import { readMarketingConsent } from "@/components/analytics/consent";

export const ANALYTICS_DEBUG_EVENT = "thecoach:analytics-debug-event";
export const ANALYTICS_DEBUG_STORAGE_KEY = "thecoach_analytics_debug_events";

export interface AnalyticsDebugEntry {
  id: string;
  name: string;
  params: Record<string, unknown>;
  consent: ReturnType<typeof readMarketingConsent>;
  status: "sent" | "blocked";
  timestamp: string;
}

export function readAnalyticsDebugEntries(): AnalyticsDebugEntry[] {
  if (typeof window === "undefined") return [];
  try {
    return JSON.parse(
      window.sessionStorage.getItem(ANALYTICS_DEBUG_STORAGE_KEY) || "[]",
    ) as AnalyticsDebugEntry[];
  } catch {
    return [];
  }
}

export function recordAnalyticsDebugEvent(
  name: string,
  params: Record<string, unknown> = {},
) {
  if (!import.meta.env.DEV || typeof window === "undefined") return;

  const consent = readMarketingConsent();
  const entry: AnalyticsDebugEntry = {
    id: crypto.randomUUID(),
    name,
    params,
    consent,
    status: consent === "granted" ? "sent" : "blocked",
    timestamp: new Date().toISOString(),
  };

  const existing = readAnalyticsDebugEntries();
  window.sessionStorage.setItem(
    ANALYTICS_DEBUG_STORAGE_KEY,
    JSON.stringify([entry, ...existing].slice(0, 50)),
  );
  window.dispatchEvent(
    new CustomEvent(ANALYTICS_DEBUG_EVENT, { detail: entry }),
  );
}
